import React, { useEffect, useState } from 'react'
import inspectionQueries from '../../queries/inspectionQueries';
import DonutChart from './DonutChart';
import { useNavigate } from 'react-router-dom';
import { RouteConstant } from '../../routes/RouteConstant';
import Loader from '../../components/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionId } from '../../redux/reducers/inspectionReducers';
import BreadCrumbs from '../../components/BreadCrumbs';

const breadCrumbsData = [
    {
        url: RouteConstant.ROOT,
        name: 'Inspections'
    },
    {
        url: RouteConstant.SECTIONPROGRESS,
        name: 'Sections'
    }
]

const SectionProgress = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const inspection_id = useSelector((state) => state.inspection.inspection_id)

    const [result, setResult] = useState([])

    const getData = inspectionQueries.useSectionProgress(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync({inspection_id})
    }, []);

    const handleClick = (data) => {
        const { section_id } = data
        dispatch(setSectionId(section_id))
        navigate(RouteConstant.QUESTIONPROGRESS)
    }

  return (
    <div>

        <BreadCrumbs  data={breadCrumbsData} />

        {
            getData?.isLoading ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div>
                {
                    result?.map((data, index) => {
                    return (
                        <div className='border-[5px] border-white bg-slate-50 w-full py-3 px-10 mb-5 rounded-[30px] shadow-md flex justify-between items-center' key={index}>
                            <div className='flex flex-col items-start gap-2'>
                                <span className='font-medium text-[18px]'>{data?.section_name}</span>
                                <span className='font-medium text-[12px] bg-primary  px-3 py-1 text-white w-fit rounded-[5px]'>{data?.category_name}</span>
                                <button
                                onClick={()=>handleClick(data)}
                                className='font-medium text-[14px] text-primary'
                                >
                                    {data?.total} Question in this section click to view
                                </button>
                            </div>
                            <DonutChart
                            data={data}
                            value={data}
                            />
                        </div>
                    )
                })}
            </div>
        }
    </div>
  )
}

export default SectionProgress
